export default __webpack_public_path__ + "static/media/hero7.17c585bb.png";